import React, {useState} from 'react'
import {Col, Row} from 'react-bootstrap'
import ProjectCodes from './ProjectCodes'
import Tools from './Tools'
import TaskTypes from './TaskTypes'

const Timesheet = () => {
  const [activeTab, setActiveTab] = useState(
    () => sessionStorage.getItem('timesheetActiveTab') || 'projectCodes'
  )

  const handleTabChange = (tab: string) => {
    setActiveTab(tab)
    sessionStorage.setItem('timesheetActiveTab', tab)
  }

  return (
    <>
      <Row>
        <Col md={12}>
          <div className='card mb-5'>
            <div className='card-header'>
              <div className='card-title'>
                <h3 className='fw-bold m-0'>Timesheet Master Data</h3>
              </div>
            </div>
            <div className='card-body'>
              <p className='text-muted'>
                Manage all master data for the timesheet module including project codes, tools, and
                task types. This data is used for timesheet entries and project assignments.
              </p>
            </div>
          </div>
        </Col>
      </Row>

      <ul className='nav nav-tabs ms-3 me-3'>
        <li className='nav-item cursor-pointer'>
          <a
            href='#project-codes'
            className={`nav-link ${activeTab === 'projectCodes' ? 'active' : ''}`}
            onClick={(e) => {
              e.preventDefault()
              handleTabChange('projectCodes')
            }}
          >
            Project Codes
          </a>
        </li>
        <li className='nav-item cursor-pointer'>
          <a
            href='#tools'
            className={`nav-link ${activeTab === 'tools' ? 'active' : ''}`}
            onClick={(e) => {
              e.preventDefault()
              handleTabChange('tools')
            }}
          >
            Tools
          </a>
        </li>
        <li className='nav-item cursor-pointer'>
          <a
            href='#task-types'
            className={`nav-link ${activeTab === 'taskTypes' ? 'active' : ''}`}
            onClick={(e) => {
              e.preventDefault()
              handleTabChange('taskTypes')
            }}
          >
            Task Types
          </a>
        </li>
      </ul>

      <div className='tab-content mt-3'>
        {activeTab === 'projectCodes' && (
          <div className='tab-pane fade show active'>
            <ProjectCodes />
          </div>
        )}
        {activeTab === 'tools' && (
          <div className='tab-pane fade show active'>
            <Tools />
          </div>
        )}
        {activeTab === 'taskTypes' && (
          <div className='tab-pane fade show active'>
            <TaskTypes />
          </div>
        )}
      </div>
    </>
  )
}

export default Timesheet

